<template>
  <div class="container mx-auto px-4 sm:px-6 lg:px-8">
    <div class="md:flex md:items-center md:justify-between my-6">
      <div class="flex-1 min-w-0">
        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
          Cardstock Settings
        </h2>
      </div>
    </div>

    <div>
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <div class="px-4 sm:px-0">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Personal Information
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              This information will be displayed publicly so be careful what you share.
            </p>
          </div>
        </div>
        <UserInfoForm :currentUser="currentUser"/>
      </div>
    </div>

    <div class="hidden sm:block">
      <div class="py-5">
        <div class="border-t border-gray-200"></div>
      </div>
    </div>

    <div>
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <div class="px-4 sm:px-0">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Call Forwarding
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              When families call your Cardstock number, we will forward the call without revealing your personal number.
            </p>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              If you leave this blank, calls to your Cardstock number will ring without being picked up.
            </p>
          </div>
        </div>
        <ForwardingNumberForm :teacher="currentTeacher"/>
      </div>
    </div>

    <div class="hidden sm:block">
      <div class="py-5">
        <div class="border-t border-gray-200"></div>
      </div>
    </div>

    <div>
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <div class="px-4 sm:px-0">
            <h3 class="text-lg font-medium leading-6 text-gray-900">
              Logging In
            </h3>
            <p class="mt-1 text-sm leading-5 text-gray-500">
              Confirm your current password and change the password to something unique and secure.
            </p>
          </div>
        </div>
        <PasswordChangeForm class="flex-grow" :currentUser="currentUser"/>
      </div>
    </div>

  </div>
</template>

<script lang="js">
import { preloadMany }  from '@/preloader'

import Container            from '@/components/Container.vue'
import ButtonSubmit         from '@/components/ButtonSubmit.vue'
import PasswordChangeForm   from '@/components/PasswordChangeForm.vue'
import UserInfoForm         from '@/components/UserInfoForm.vue'
import ForwardingNumberForm from '@/components/ForwardingNumberForm.vue'

import CurrentTeacherQuery from '@/queries/CurrentTeacher.gql'

const preloadQueries = (to) => {
  return [
    {
      query: CurrentTeacherQuery,
      queryName: 'currentTeacher',
      variables: {
        teamId: to.params.teamId
      },
      fetchPolicy: 'network-only'
    },
  ]
}

export default {
  components: {
    ButtonSubmit,
    Container,
    ForwardingNumberForm,
    PasswordChangeForm,
    UserInfoForm
  },

  props: ['currentUser', 'teamId'],

  mounted() {
    this.proposedFirst = this.currentUser.first
    this.proposedLast = this.currentUser.last
    this.proposedEmail = this.currentUser.email
  },

  beforeRouteEnter(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next
    })
  },

  beforeRouteUpdate(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next,
      mountedVm: this
    })
  },

  watch: {
    currentUser: function (newCurrentUser, oldCurrentUser) {
      console.log('watcher')
      this.proposedFirst = newCurrentUser.first
      this.proposedLast = newCurrentUser.last
      this.proposedEmail = newCurrentUser.email
    }
  },

  apollo: {
    currentTeacher: {
      query: CurrentTeacherQuery,
      queryName: 'currentTeacher',
      variables() {
        return { teamId: this.teamId }
      },
      fetchPolicy: 'cache-first'
    },
  }
}
</script>
